/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#images[_ngcontent-%COMP%]{padding-top:1rem}#images[_ngcontent-%COMP%]   .image-cell[_ngcontent-%COMP%]{display:inline-block;vertical-align:top;text-align:center;margin:0 .5rem .75rem 0}#images[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:block;margin:0 auto;max-width:12rem;max-height:12rem;height:auto;cursor:pointer}#images[_ngcontent-%COMP%]   .dicom-header-link[_ngcontent-%COMP%]{margin:.25rem 0 0}"];
export { styles as styles };

